<template>
  <div>
    <div style="padding: 0 32px;">
      <section-header :ressource="ressourceHeader"
                      :isExtended='true'
                      :dialog="true"
                      @closeDialog=closeDialog>
      </section-header>
    </div>

    <v-row class="flex-nowrap card-row" style="overflow-x: auto;height: 100%;padding: 32px;">
      <v-col v-for="(option, index) in listItems"
             :key="option.id"
             class="flex-shrink-0"
             cols="auto">
        <v-card class="custom-card"
                elevation="2"
                shaped
                outlined>
          <div style="height: 300px;">
            <div class="subscription-title">
              <span :class="option.mensuel == 0 ? 'free-label' : 'star-label'">
                {{ option.mensuel == 0 ? 'FREE' : '★'.repeat(index) }}
              </span>
              <span class="subscription-title">
                {{ formattedTitle(option) }}
              </span>
            </div>
            <div class="subscription-subtitle space-adjustment">
              <span>{{ formattedSubscriptionMaxPaie(option) }}</span>
            </div>
            <div class="subscription-mensuel-container">
              <span class="subscription-mensuel">{{ `${option.mensuel.toFixed(2)} € ` }}</span>
              <span class="mensuel-tax">HT par mois</span>
            </div>
            <div class="paiePrix space-adjustment">
              <span>{{ formattedPaiePrix(option) }}</span>
            </div>
            <div class="bouton-selection-inscription space-adjustment">
              <div>
                <loader-button class="subscription-button"
                               type="submit"
                               :label="getAction(option)"
                               :outlined="outlined(option)"
                               :disabled="!option.canSubscribe"
                               :full-width="true"
                               @callback="offreSelectionner(option)">
                </loader-button>
              </div>
            </div>

            <div class="desc-abo">
              {{ option.description }}
            </div>
          </div>
          <!--          <div class="select-subscription-url">
                      <a :href="option.url" class="subscription-link" target="_blank" rel="noopener">
                        Voir les services pour {{ formattedTitle(option) }}
                      </a>
                    </div>-->
        </v-card>
      </v-col>
    </v-row>

    <div class="section-subscription-url">
      <a href="https://www.cheque-intermittents.com/pricing/?origine=ci24" class="subscription-url"
         target="_blank"
         rel="noopener">
        Plus de détails sur nos offres d’abonnement
      </a>
    </div>

    <div class="subscription-mention" v-html="ressourceMention"></div>

    <div v-if="subscription && subscription.id > 0" class="d-flex flex-row-reverse pt-3">
      <span class="btn-resilier" @click="goToDialog">
        Résilier mon abonnement
      </span>
    </div>
  </div>
</template>

<script lang="ts">
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { defineComponent, type PropType } from "vue";
  import { GenSection, RessourceGenSection } from "@/generated/ressources/generatedRessources.ts";
  import { storeEtablissement, storeSubscription } from "@/generated/stores";
  import LoaderButton from "@/framework/base/components/LoaderButton.vue";
  import Subscription from "@/generated/classes/Subscription";
  import SubscriptionType from "@/generated/classes/SubscriptionType";
  import { MapRessource } from '@/framework/base/helpers/Ressources';
  import { DateFormat } from '@/framework/base/helpers/DateFormat';
  import { AppCustoms, RessourceAppCustom } from "@/ressources/globalRessources.ts";
  import Etablissement from '@/extend/classes/Etablissement';
  import { ListFilter } from "@/generated/classes/ListData";

  export default defineComponent({
    components: {
      LoaderButton,
      SectionHeader
    },
    props: {
      ownerId: {
        type: Number,
      },
      subscriptionTypeSelected: {
        type: Number,
        required: true,
      },
      listItems: {
        type: Array as PropType<SubscriptionType[]>,
      }
    },
    computed: {
      etablissement() {
        return storeEtablissement.getEtablissement(this.ownerId);
      },
      suggestedSubscriptionTypeId(): number {
        return this.etablissement.suggestedSubscriptionTypeId;
      },
      subscription() {
        if (this.etablissement.subscriptionId > 0) {
          return storeSubscription.getSubscription(this.etablissement.subscriptionId);
        } else {
          return new Subscription();
        }
      },
      ressourceHeader() {
        if (this.etablissement.alias != '') {
          const headerResource = RessourceGenSection(GenSection.SUBSCRIPTION);
          headerResource.label = 'Abonnement pour ' + this.etablissement.alias;
          return headerResource;
        } else {
          return new MapRessource();
        }
      },
      ressourceMention() {
        return RessourceAppCustom(AppCustoms.SUSBCRIPTION_SELECTION_MENTION).label
      }
    },
    methods: {
      formattedTitle(option: SubscriptionType) {
        return option.label.charAt(0).toUpperCase() + option.label.slice(1).toLowerCase()
      },
      formattedSubscriptionMaxPaie(option: SubscriptionType) {
        let label = '';
        if (option.maxPaies > 0) {
          label = 'Jusqu’à ' + option.maxPaies + ' bulletins de paie par an';
        } else if (option.mensuel == 0) {
          label = 'Sans abonnement et sans engagement';
        } else {
          label = 'Nombre illimité de bulletins de paie';
        }
        return label;
      },
      formattedPaiePrix(option: SubscriptionType) {
        if (option.mensuel == 0) {
          return `+ à partir de ${option.dossier + option.minTraitement} € / bulletin de paie (*)`;
        } else {
          return `+ à partir de ${option.dossier + option.minTraitement} € / bulletin de paie (**)`;
        }
      },
      outlined(option: SubscriptionType): boolean {
        return option.id == this.subscriptionTypeSelected ||
          this.suggestedSubscriptionTypeId > 0 && option.id != this.etablissement.suggestedSubscriptionTypeId;
      },
      getAction(option: SubscriptionType) {
        if (this.subscriptionTypeSelected == option.id) {
          if (this.subscription.dateResiliation != null) {
            return 'Resilié le ' + DateFormat.getDateLabel(this.subscription.dateResiliation);
          } else {
            return 'Votre offre actuelle'
          }
        } else {
          if (this.subscription.dateResiliation != null && this.subscription.resiliationPrelude && option.mensuel == 0) {
            return 'Active le ' + DateFormat.getDateLabel(this.subscription.dateResiliation);
          } else {
            if (this.suggestedSubscriptionTypeId == option.id) {
              return 'Choisir l\'offre suggérée';
            } else {
              return 'Choisir cette offre';
            }
          }
        }
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
      offreSelectionner(offreSelectionner: SubscriptionType) {
        if (this.subscription.dateResiliation != null && this.subscriptionTypeSelected == offreSelectionner.id) {
          this.$emit('goToDialog');
        } else {
          this.$emit('offreSelectionner', offreSelectionner);
        }
      },
      goToDialog() {
        this.$emit('goToDialog');
      }
    }
  })
</script>

<style>
  .subscription-url {
    font-size: 14px;
    font-weight: 500;
    color: #E31F1C;
  }

  .section-subscription-url {
    padding: 16px;
    padding-left: 32px;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .subscription-mention {
    color: #135253;
    font-size: 9px;
    font-weight: 400;
    padding: 0 32px;
  }

  .btn-resilier {
    color: #09292A;
    font-size: 14px;
    cursor: pointer;
  }

    .btn-resilier:hover {
      opacity: 0.8;
    }

  .custom-card {
    width: 252px;
    border-radius: 16px;
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    letter-spacing: 0;
  }

  .subscription-title {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 4px;
  }

  .free-label {
    font-size: 10px;
    gap: 4px;
    color: #171A1C;
    transform: translateY(10px)
  }

  .star-label {
    font-size: 24px;
    gap: 4px;
    color: #171A1C;
  }

  .subscription-title {
    font-size: 24px;
    font-weight: 600;
    color: #171A1C;
  }

  .subscription-subtitle {
    font-size: 11px;
    font-weight: 400;
    color: #135253;
  }

  .subscription-mensuel {
    font-size: 24px;
    font-weight: 600;
    color: #171A1C;
  }

  .mensuel-tax {
    font-size: 11px;
    font-weight: 500;
    color: #2ECCD1;
  }

  .paiePrix {
    font-size: 11px;
    font-weight: 400;
    color: #135253;
  }

  .bouton-selection-inscription {
    padding-left: -20px;
  }

    .bouton-selection-inscription .subscription-button .outlined {
      background-color: transparent;
    }

  .desc-abo {
    font-size: 11px;
    font-weight: 400;
    color: #135253;
  }

  .subscription-link {
    font-size: 11px;
    font-weight: 500;
    color: #E31F1C;
  }

  .space-adjustment {
    padding-bottom: 24px;
  }

  .select-subscription-url {
    padding-top: 4px;
  }
</style>